import { render, staticRenderFns } from "./CustomPropertiesInput.vue?vue&type=template&id=0067e1c0&"
import script from "./CustomPropertiesInput.vue?vue&type=script&lang=js&"
export * from "./CustomPropertiesInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports